'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

type Filter = 'all' | 'members' | 'public' | 'past';

export default function FilterChips({ active }: { active: Filter }) {
  const router = useRouter();
  const pathname = usePathname();
  const sp = useSearchParams();

  const navigate = (next: Filter) => {
    const params = new URLSearchParams(sp.toString());
    // フィルタ変更時はページ番号をリセット（空ページになりにくくする）
    params.delete('page');
    if (next === 'all') {
      params.delete('filter');
    } else {
      params.set('filter', next);
    }
    const url = `${pathname}${
      params.toString() ? `?${params.toString()}` : ''
    }`;
    router.push(url);
    router.refresh();
  };

  const chipCls = (isActive: boolean) =>
    `inline-flex h-9 shrink-0 items-center justify-center whitespace-nowrap rounded-full px-4 text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white ${
      isActive
        ? 'bg-primary text-white'
        : 'border border-secondary bg-white text-secondary'
    }`;

  return (
    <div className='flex flex-col items-center'>
      <div className='flex flex-wrap items-center justify-center gap-2 md:gap-3'>
        <button
          aria-current={active === 'all' ? 'page' : undefined}
          onClick={() => navigate('all')}
          className={chipCls(active === 'all')}
        >
          全て
        </button>
        <button
          aria-current={active === 'members' ? 'page' : undefined}
          onClick={() => navigate('members')}
          className={chipCls(active === 'members')}
        >
          会員限定
        </button>
        <button
          aria-current={active === 'public' ? 'page' : undefined}
          onClick={() => navigate('public')}
          className={chipCls(active === 'public')}
        >
          一般参加可
        </button>
        <button
          aria-current={active === 'past' ? 'page' : undefined}
          onClick={() => navigate('past')}
          className={chipCls(active === 'past')}
        >
          過去イベント
        </button>
      </div>
    </div>
  );
}
